export class ReaderConnectionResponse {

  //{"address":"00:17:E9:FA:CE:16","battery":15,
  // "manufacture":"Zebra Tech Inc","maxPower":300,
  // "minPower":0,"model":"RFD8500-5000100-US",
  // "name":"RFD850015315523024904","soundLevels":4,"type":"ZEBRA"}


  public address: string;

  public battery: number;

  public manufacture: string;

  public maxPower: number;

  public minPower: number;

  public model: string;

  public name: string;

  public soundLevels: number;

  public type: string;

  public message: string;
}



// WEBPACK FOOTER //
// ./src/models/reader-model/readerConnectionResponse.ts